// extracted by mini-css-extract-plugin
module.exports = {"dotsContainer":"DotsPattern_dotsContainer__q5g_w"};